import React from 'react'
import { useGLTF } from '@react-three/drei'

import BasamentoGenerale from './BasamentoGenerale';

export function BasamentoFacility() { 
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/basi/facilityBase.gltf`);
  const yOffset = 0.057;

  return (
    <BasamentoGenerale nodeCorpoName={nodes.Mesh_4.geometry}                      
                        pos1={[0, yOffset, 0]}
                        rot1={[-Math.PI / 2, 0, 0]}                       
                        sc1={0.1}                      
                        mainRotation={[0, -Math.PI / 2, 0]}              
    />
  )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/models/basi/facilityBase.gltf`)

